var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRemoteSelect',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":(c) => (`${c.uid}-${c.name}`),"find_api":_vm.$util.api.find_contract,"search_api":_vm.$util.api.contract_select_search,"item-default":{id: 0, uid: '', name: ''}}},'VRemoteSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }